import React from 'react';
import { Box, Button, RadioGroup, Radio, FormControl, FormControlLabel } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import Modal from 'components/Modal';
import { Input } from 'components/Form';
import clsx from 'clsx';
import classes from './Modal.module.scss';

const UpdateDateModal = ({ open, handleSubmit, handleClose, defaultValue, isReminder = false }) => {
  const [mode, setMode] = React.useState('not-available');
  const [value, setValue] = React.useState(defaultValue || new Date());
  const [parsedValue, setParsedValue] = React.useState('');
  const [note, setNote] = React.useState('');
  const handleChangeMode = (value) => {
    setMode(value);
  };
  const resetState = () => {
    setValue(defaultValue || new Date());
    setParsedValue('');
    setNote('');
    setMode('not-available');
  };

  React.useEffect(() => {
    if (defaultValue) {
      setValue(defaultValue || new Date());
    }
  }, [defaultValue]);

  return (
    <Modal
      modalProps={{
        className: { classRoot: classes.root },
        open,
        handleClose: () => {
          handleClose(resetState);
        },
        title: isReminder ? 'Set Reminder' : 'Set Expiry Date',
        size: 'small',
        footer: (
          <>
            <Button
              disabled={!value}
              className={classes.button}
              color='primary'
              variant='contained'
              onClick={() => {
                handleSubmit(
                  mode === 'not-available' ? '' : value,
                  mode === 'not-available' ? '' : parsedValue,
                  note,
                  resetState
                );
              }}>
              Confirm
            </Button>
          </>
        ),
      }}>
      <Box>
        <Box className={classes.radioGroup}>
          <FormControl component='fieldset'>
            <RadioGroup
              row
              aria-label='gender'
              name='gender1'
              value={mode}
              onChange={(event) => {
                handleChangeMode(event.target.value);
              }}>
              <FormControlLabel value='not-available' control={<Radio />} label='Not Available' />
              <FormControlLabel value='custom' control={<Radio />} label='Custom' />
            </RadioGroup>
          </FormControl>
        </Box>
        {mode === 'custom' && (
          <Box>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                className={clsx(classes.textField, classes.textField__expiryDate)}
                disableToolbar
                variant='inline'
                format='dd/MM/yyyy'
                margin='normal'
                id='date-picker-inline'
                inputVariant='outlined'
                value={value}
                onChange={(date, newValue) => {
                  setParsedValue(newValue);
                  setValue(date);
                }}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />
            </MuiPickersUtilsProvider>
            {isReminder && (
              <Input
                inputProps={{}}
                className={classes.textArea}
                onChange={(event) => {
                  setNote(event.target.value);
                }}
                value={note}
                multiline
                type='text'
                label='Remarks (optional)'
                placeholder='Note to yourself'
              />
            )}
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default UpdateDateModal;
